import { useContext } from 'react'
import { TimeZoneContext } from 'context/common/TimeZoneContext'

/**
 * Renders the wrapped component only after timezone context has been hydrated
 * from sessionStorage. Prevents flashing incorrect timezone content on first paint.
 */
const withTimezoneInitialized = <P extends Record<string, unknown>>(
  WrappedComponent: React.FC<P>
): React.FC<P> => {
  const WithTimezoneInitialized: React.FC<P> = (props) => {
    const { isInitialized } = useContext(TimeZoneContext)

    if (!isInitialized) {
      return null
    }

    return <WrappedComponent {...props} />
  }

  WithTimezoneInitialized.displayName = `withTimezoneInitialized(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`

  return WithTimezoneInitialized
}

export default withTimezoneInitialized
